import { UnstyledButton } from '../basics/UnstyledButton';
import PatternListDropdown from '../PatternListDropdown';

const SelectedPatternDropdown = ({
  patternName,
  patternId,
  onSelectPattern,
  onRemoveClick,
}) => {
  return (
    <div className="d-flex align-items-center">
      <PatternListDropdown
        title={
          <div className="text-dark text-truncate" title={patternName}>
            {patternName}
          </div>
        }
        onSelectPattern={onSelectPattern}
        selectedPatternId={patternId}
        color="light"
        size="sm"
        className="d-flex align-items-center overflow-hidden"
      />
      {onRemoveClick && (
        <UnstyledButton className="ml-1 font-large" onClick={onRemoveClick}>
          ×
        </UnstyledButton>
      )}
    </div>
  );
};

export default SelectedPatternDropdown;
